import React from "react";
import { useParams } from "react-router-dom";

import { EventDealTermsPanel } from "../../components/events/EventDealTermsPanel";

/** Deals tab — Deal Terms previously lived on Overview (Sprint 5 Aug 26). */
const EventDealsPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  if (!eventId) {
    return (
      <div className="app-shell-dash-panel">
        <p className="eventos-subtle">Select an event to manage deal terms.</p>
      </div>
    );
  }

  return (
    <div className="event-deals-page">
      <EventDealTermsPanel eventId={eventId} />
    </div>
  );
};

export default EventDealsPage;
